import * as React from 'react';
import {
  InteractionStatus,
} from "@azure/msal-browser";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import Typography from "@mui/material/Typography";
import { useState, useEffect } from "react";
import {
  createManagedAuthAdapter,
  createStorageBrowser,
  componentsDefault
} from '@aws-amplify/ui-react-storage/browser';
import '@aws-amplify/ui-react/styles.css';
import { SignInButton } from "../ui-components/SignInButton";
import { transferConfig } from "../authConfig";


import { Button, Flex, Text } from '@aws-amplify/ui-react';


const StorageBrowserComponent = ({ credentials }) => {
  const { StorageBrowser, useView } = createStorageBrowser({
    // elements: componentsDefault, // replace to customize your UI
    config: createManagedAuthAdapter({
      credentialsProvider: async () => credentials,
      // AWS `region` and `accountId`
      region: 'ap-southeast-2',
      accountId: transferConfig.awsTokenIssuer.awsAccountNumber,
      // call `onAuthStateChange` when end user auth state changes 
      // to clear sensitive data from the `StorageBrowser` state
      registerAuthListener: (onAuthStateChange) => { },
    })
  });

  function MyStorageBrowser() {
    const state = useView('LocationDetail');
    const [currentAction, setCurrentAction] = React.useState();
  

    if (!state.location.current) {
      return <CustomLocationsView />;
    }

    if( ! currentAction && state.location.current.bucket && state.location.current.bucket.endsWith('-upload')) {
      setCurrentAction('upload');
    }

    if (currentAction) {
      return (
        <StorageBrowser.LocationActionView
          type={currentAction}
          onExit={() => {
            setCurrentAction(undefined);
            state.location.current = undefined;
          }}
        />
      );
    }
  

    return (
      <StorageBrowser.LocationDetailView
        key={currentAction}
        onActionSelect={(action) => {
          setCurrentAction(action);
        }}
        onExit={
          state.location = undefined
        }
      />
    );
  }

  function formatLocation(bucket: string, prefix: string): string {
    // Define regex patterns for bucket and prefix

    // console.log('Prefix: ', prefix)
    // console.log('Bucket: ', bucket)

    const bucketComponents = bucket.split('-');
    var environment;
    var direction;
    var directionNarrative;
    var folderNarrative;

    if(bucketComponents[0] !== 'forgov') {
      return "Invalid bucket format";
    }

    if (bucketComponents.length == 2) {
      environment = 'prod';
      direction = bucketComponents[1];
    } else if (bucketComponents.length == 3) {
      environment = bucketComponents[1];
      if(environment !== 'dev' && environment !== 'test') {
        return `Invalid bucket environment ${environment} (must be dev/test/prod)`;
      }
      direction = bucketComponents[2];
    }

    if(direction == 'upload') {
      directionNarrative = 'Upload to';
    } else if (direction == 'download') {
      directionNarrative = 'Download from';
    } else {
      return "Invalid bucket direction (must be upload/download)";
    }

    const prefixComponents = prefix.split('/');
    // console.log('Prefix Components: ', prefixComponents)

    if (prefixComponents[0] == localStorage.getItem('userSub')) {
      prefixComponents.shift();
    }
    if (prefixComponents[1] == 'DataTransfer') {
      accountType == 'relativity'
    } else {
      accountType == 'euc'
    }

    const accountComponents = prefixComponents[0].split('-');
    if (accountComponents.length !== 2) {
      return "Invalid prefix format";
    }
    // console.log('Account Components: ', accountComponents)
    const accountType = accountComponents[0];
    const accountEnv = accountComponents[1];

    if (accountType == 'relativity') {
      if (prefixComponents.includes ('FileShareExport')) {
        if (environment == 'dev'){
          folderNarrative = `File Share (dev)`;
        } else if (environment == 'test'){
          folderNarrative = `File Share (test)`;
        } else {
          folderNarrative = `File Share`;
        }
      } else if (prefixComponents.includes ('FileShareImport')) {
        if (environment == 'dev'){
          folderNarrative = `File Share (dev)`;
        } else if (environment == 'test'){
          folderNarrative = `File Share (test)`;
        } else {
          folderNarrative = `File Share`;
        }
      } else { 
        folderNarrative = `Relativity Workspace ${prefixComponents[1]} (${accountEnv})`; 
      }
    } else if (accountType == 'euc') {
        if (environment == 'dev'){
          folderNarrative = `My Virtual Desktop (dev)`;
        }else if (environment == 'test') {
          folderNarrative = `My Virtual Desktop (test)`;
        } else {
          folderNarrative = `My Virtual Desktop`;
        }
    } else {
      folderNarrative = accountType
    }

    // console.log('Folder Narrative: ', folderNarrative)
    return `${directionNarrative} ${folderNarrative}`;

  }
  

  function CustomLocationsView() {
    const state = useView('Locations');
  
    return (
      <Flex direction="column" padding="medium">
        <Text fontWeight="bold">Locations</Text>
        {state.pageItems.map((location) => {
          return (
            <Button
              key={location.id}
              justifyContent="flex-start"
              onClick={() => {
                state.onNavigate(location);
              }}
            >
              <Text flex="1">
                {formatLocation(location.bucket, location.prefix)}
              </Text>
            </Button>
          );
        })}
      </Flex>
    );
  }

  return (
    <StorageBrowser.Provider>
      <MyStorageBrowser />
    </StorageBrowser.Provider>
  );
};

export function Home() {
  const { instance, inProgress } = useMsal();
  const [credentials, setCredentials] = useState(null);

  useEffect(() => {
    const fetchCredentials = async () => {
      const account = instance.getActiveAccount();
      if (account) {
        const idToken = account.idToken;
        try {
          const creds = await assumeAwsRole(idToken);
          setCredentials(creds);
        } catch (error) {
          console.error(error);
        }
      } else {
        console.error("No active account found");
      }
    };

    if (inProgress === InteractionStatus.None && !credentials) {
      fetchCredentials();
    }
  }, [instance, inProgress, credentials]);

  const decodeJwt = (token) => {
    try {
      const payload = token.split('.')[1];
      const decodedPayload = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
      return JSON.parse(decodedPayload);
    } catch (error) {
      console.error('Failed to decode JWT:', error);
      return null;
    }
  };

  const assumeAwsRole = async (web_identity_token) => {
    const firstRoleParams = {
      DurationSeconds: 900,
      RoleArn: transferConfig.awsTokenIssuer.awsOidcRole,
      RoleSessionName: "dfg-au-transfer-webui",
      WebIdentityToken: web_identity_token
    };

    const tokenExchangeParams = {
      clientId: transferConfig.awsTokenIssuer.awsIdentityCenterApplicationClientArn,
      grantType: "urn:ietf:params:oauth:grant-type:jwt-bearer",
      assertion: web_identity_token,
    };

    AWS.config.update({ region: "ap-southeast-2" });

    try {
      const sts = new AWS.STS();
      const data = await sts.assumeRoleWithWebIdentity(firstRoleParams).promise();

      const webIdentityParams = {
        region: 'ap-southeast-2',
        accessKeyId: data.Credentials.AccessKeyId,
        secretAccessKey: data.Credentials.SecretAccessKey,
        sessionToken: data.Credentials.SessionToken
      };

      const webIdentitySsooidc = new AWS.SSOOIDC(webIdentityParams);
      const webIdentitySts = new AWS.STS(webIdentityParams);

      const tokenData = await webIdentitySsooidc.createTokenWithIAM(tokenExchangeParams).promise();
      const token_id_token_decoded = decodeJwt(tokenData.idToken);

      const enhanancedRoleParams = {
        RoleArn: transferConfig.awsTokenIssuer.awsIdEnhancedRole,
        RoleSessionName: "s3-explorer-" + token_id_token_decoded['sub'],
        ProvidedContexts: [
          {
        "ProviderArn": "arn:aws:iam::aws:contextProvider/IdentityCenter",
        "ContextAssertion": token_id_token_decoded['sts:identity_context']
          }
        ]
      };

      // Store the token_id_token_decoded['sub'] value in localStorage for later use
      localStorage.setItem('userSub', token_id_token_decoded['sub']);

      const enhancedRoleData = await webIdentitySts.assumeRole(enhanancedRoleParams).promise();

      return {
        credentials: {
          accessKeyId: enhancedRoleData.Credentials.AccessKeyId,
          secretAccessKey: enhancedRoleData.Credentials.SecretAccessKey,
          sessionToken: enhancedRoleData.Credentials.SessionToken,
          expiration: new Date(enhancedRoleData.Credentials.Expiration)
        }
      };

    } catch (err) {
      console.log(err, err.stack); // an error occurred
      await instance.logoutRedirect({
        onRedirectNavigate: (url) => {
            return false;
        }
      });
    }
  };

  return (
    <>
      <AuthenticatedTemplate>
        {credentials ? <StorageBrowserComponent credentials={credentials} /> : <Typography><br/>Loading...</Typography>}
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Typography variant="h6">
          <br/>
          <center>Please login to access the service</center>
          <br/>
          <center><SignInButton /></center>
        </Typography>
      </UnauthenticatedTemplate>
    </>
  );
}